import React from "react"

import { BrowserRouter, Route, Routes } from "react-router-dom"

import About from "pages/About"
import Detail from "pages/Detail"
import Landing from "pages/Landing"
import Legal from "pages/Legal"
import UsedVehicles from "pages/UsedVehicles"
import Contract from "pages/Contract"
import MyGarage from "pages/MyGarage"
import Profile from "pages/Profile"
import Login from "pages/Login"
import NotFound from "pages/NotFound"

import "./App.sass"

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" exact element={<Landing/>} />

        <Route path="/search/:vin/" exact element={<Detail/>} />
        <Route path="/kupoprodajna-pogodba/" exact element={<Contract/>} />
        <Route path="/moja-garaza/" exact element={<MyGarage/>} />
        <Route path="/profil/" exact element={<Profile/>} />
        <Route path="/prijava/" exact element={<Login/>} />
        <Route path="/legal/" exact element={<Legal/>} />
        <Route path="/faq/" element={<About/>} />
        <Route path="/rabljenavozila/" exact element={<UsedVehicles/>} />

        <Route element={<NotFound/>} />
      </Routes>
    </div>
  )
}

export default App
